import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const requestsWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    {
      path: '/requests',
      component: () => import('./pages/ListPage.js').then((m) => ({ default: m.MinePage })),
    },
    {
      path: '/requests/inbox',
      component: () => import('./pages/ListPage.js').then((m) => ({ default: m.InboxPage })),
    },
    {
      path: '/requests/all',
      component: () => import('./pages/ListPage.js').then((m) => ({ default: m.AllPage })),
    },
    {
      path: '/requests/new',
      component: () => import('./pages/FormPage.js').then((m) => ({ default: m.NewRequestPage })),
    },
    { path: '/requests/leave', component: () => import('./pages/LeavePage.js') },
    { path: '/requests/payments', component: () => import('./pages/PaymentsPage.js') },
    { path: '/requests/purchases', component: () => import('./pages/PurchasesPage.js') },
    {
      path: '/requests/types',
      component: () => import('./pages/TypesPage.js').then((m) => ({ default: m.TypesPage })),
    },
    {
      path: '/requests/types/$typeId',
      component: () => import('./pages/TypesPage.js').then((m) => ({ default: m.TypeEditorPage })),
    },
    { path: '/requests/$requestId', component: () => import('./pages/DetailPage.js') },
    {
      path: '/requests/$requestId/edit',
      component: () => import('./pages/FormPage.js').then((m) => ({ default: m.EditRequestPage })),
    },
  ],
  widgets: {
    'requests.inbox': () => import('./InboxWidget.js'),
    'requests.leave': () => import('./LeaveWidget.js'),
    'requests.advances': () => import('./AdvancesWidget.js'),
  },
});
